import { moduleFactory } from "@/store/resource";

const resourceModule = moduleFactory("moderatorOnline");
resourceModule.getters.online = state => id => {
  return (
    state.moderatorOnlines.filter(online => {
      return online.id == id;
    }).length > 0
  );
};

export const moderatorModule = resourceModule;
